export abstract class AbstractStartOverButtonService {
  public abstract startVideoOver(guid: string, publicId: string): void;
}
